import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import Markdown from 'react-markdown';
import { useStreamingReveal } from '../hooks/useStreamingReveal';
import { REMARK_PLUGINS } from './markdown-config';
/**
 * TypewriterText — animates new text character-by-character.
 *
 * Text is revealed one character at a time via `useStreamingReveal`, then rendered
 * through `react-markdown` for full markdown support. The character-by-character
 * reveal itself IS the animation — no imperative DOM manipulation is used, so
 * React's reconciler always owns the DOM tree.
 */
export const TypewriterText = memo(function TypewriterText({ text, animated = true, charDelayMs = 10, markdownComponents, }) {
    const { revealedText, isRevealing } = useStreamingReveal(text, animated, { charDelayMs });
    return (_jsxs("div", { children: [_jsx(Markdown, { remarkPlugins: REMARK_PLUGINS, components: markdownComponents, children: revealedText }), isRevealing && _jsx("span", { className: "streaming-cursor", "aria-hidden": "true" })] }));
});
//# sourceMappingURL=TypewriterText.js.map